import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Invoice\AddSendRecordToInvoiceController::__invoke
* @see app/Http/Controllers/Invoice/AddSendRecordToInvoiceController.php
* @route '/api/invoicing/{invoice}/send-record'
*/
const AddSendRecordToInvoiceController = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: AddSendRecordToInvoiceController.url(args, options),
    method: 'post',
})

AddSendRecordToInvoiceController.definition = {
    methods: ["post"],
    url: '/api/invoicing/{invoice}/send-record',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Invoice\AddSendRecordToInvoiceController::__invoke
* @see app/Http/Controllers/Invoice/AddSendRecordToInvoiceController.php
* @route '/api/invoicing/{invoice}/send-record'
*/
AddSendRecordToInvoiceController.url = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { invoice: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { invoice: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            invoice: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        invoice: typeof args.invoice === 'object'
        ? args.invoice.id
        : args.invoice,
    }

    return AddSendRecordToInvoiceController.definition.url
            .replace('{invoice}', parsedArgs.invoice.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Invoice\AddSendRecordToInvoiceController::__invoke
* @see app/Http/Controllers/Invoice/AddSendRecordToInvoiceController.php
* @route '/api/invoicing/{invoice}/send-record'
*/
AddSendRecordToInvoiceController.post = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: AddSendRecordToInvoiceController.url(args, options),
    method: 'post',
})

export default AddSendRecordToInvoiceController